module.exports = __webpack_public_path__ + "src/assets/models/petri/spots_2.fbx";